<template>
	<div class="shopping">
		<van-nav-bar :title="title" fixed border>
			<template #left>
				<img src="../../assets/img/icon/left-arrow.png" class="icon" @click="goBack()" />
			</template>
		</van-nav-bar>
		<div class="collapse" v-if="Object.keys(shoppingCart).length==0">
			<div class="empty">
				<span class="msg">购物车空空也</span>
			</div>
		</div>

		<div class="collapse" v-else>
			<van-checkbox-group v-model="shoppingRst" ref="shoppingCheckboxGroup">
				<div class="col-item" v-for="(store, s_id) in shoppingCart" :key="s_id">
					<div class="msg">
						<div class="topic">
							<img :src="attach_url+store.store.s_img" alt />
							<span class="title">{{store.store.s_name}}</span>
						</div>
						<span class="time"><van-icon name="delete"  @click="removeShoppingCart(s_id)" class="color_red" size="16px"/></span>
					</div>
					<div class="content">
						<van-notice-bar left-icon="info-o" :style="{'font-size':'12px','height': '28px'}">
							{{store.express?('满'+store.express+'元起可配送！'):'无配送'}}
							<template #right-icon v-if="store.express">
								<van-icon name="question-o"  @click.stop="getExpress(s_id, store.store.s_name)" class="skin_color"/>
							</template>
						</van-notice-bar>
					</div>
					<div class="content">
						<van-checkbox shape="square" :name="s_id+'#'+index" v-for="(item,index) in store.cart" :key="index">
							<van-swipe-cell>
								<van-card
									:price="item.g_price"
									:title="item.g_name"
									:thumb="attach_url+item.g_img"
									class="van-card-small"
								>
									<template #num >
										<div class="van-card-num" @click.stop="stepStop">
											<van-stepper v-model.number="item.buys" :step="item.g_min_buy" integer input-width="40px" :max="item.g_day_limit>0?item.g_day_limit:item.g_stock"/>
											&nbsp;{{goodUnitObj[item.g_unit]}}
										</div>
									</template>
									<template #footer v-if="item.g_sku_str">
										已选：{{item.g_sku_str}}
									</template>
								</van-card>
								<template #right>
									<van-button square text="移除" type="danger" class="van-swipe-cell-button"  @click="removeShoppingCartGood(s_id, index)"/>
								</template>
							</van-swipe-cell>
						</van-checkbox>
					</div>
					<div class="content">
						<van-cell-group>
							<van-field v-model="storeOrderRemark[s_id].remark" label="备注：" label-width="50px" maxlength="100"> </van-field>
						</van-cell-group>
					</div>
				</div>
				<van-submit-bar :price="shoppingCart|sumOrderPrice(shoppingRst)" button-text="提交订单" @submit="submitShoppingCart()">
					<van-checkbox v-model="shoppingAll" @click="chgShoppingAll">全选</van-checkbox>
					<template #tip v-if="chkIncExpress(shoppingCart,shoppingRst)">
						{{selAddressInfo?(selAddressInfo.area+' '+selAddressInfo.address+','+selAddressInfo.name+'('+selAddressInfo.telphone+')'):'订单有可配送服务，自提请忽略！'}}
						
						<span @click="onShowChosenAddress" class="skin_color" v-if="u_id&&token">{{selAddressInfo?'切换地址':'选择地址'}}</span>
						<span @click="onEditTempAddress" class="skin_color" v-else>{{selAddressInfo?'修改地址':'填写地址'}}</span>
						<van-icon name="close" :style="{'float':'right'}" class="color_red" v-if="selAddressInfo" @click="selAddressInfo=false"/>
					</template>
				</van-submit-bar>
			</van-checkbox-group>
		</div>

		<van-popup v-model="showExpress" position="bottom" :style="{ 'max-height': '80%' }">
			<van-divider>
				配送资费
			</van-divider>

			<van-cell-group>
				<van-cell :value="storeExpress.min_order_amount" title="最低：">
					<template #right-icon>元起送</template>
				</van-cell>
			</van-cell-group>

			<van-cell-group>
				<van-cell :value="storeExpress.free" title="免费送：">
					<template #right-icon>公里内</template>
				</van-cell>
			</van-cell-group>

			<van-cell-group>
				<van-cell :value="storeExpress.markup" title="加价送：">
					<template #right-icon>公里内</template>
				</van-cell>
				<van-cell :value="storeExpress.markup_amount" title="每公里加收：">
					<template #right-icon>元</template>
				</van-cell>
			</van-cell-group>

			<van-divider>
				快递收费
			</van-divider>

			<van-cell-group v-for="(exp, ind) in storeExpress.expressList" :key="ind" :style="{display:'flex'}">
				<van-cell :value="exp.distance" title="" :style="{width:'50%'}">
					<template #right-icon>公里内</template>
				</van-cell>
				<van-cell :value="exp.amount" title="" :style="{width:'50%'}">
					<template #right-icon>元</template>
				</van-cell>
			</van-cell-group>

			<van-cell-group>
				<van-cell :value="storeExpress.markup_max" title="最高收费：">
					<template #right-icon>元</template>
				</van-cell>
			</van-cell-group>
			
			<div style="display:flex;">
				<van-button type="primary" block @click="showExpress=!showExpress" >知道了</van-button>
			</div>
		</van-popup>

		<van-popup v-model="showChosenAddress" round position="bottom" class="popup_select" :style="{ 'max-height': '80%'}">
			<van-address-list
			  v-model="chosenAddressId"
			  :list="chosenAddress"
			  default-tag-text="默认"
			  @add="onAddAddress"
			  @edit="onEditAddress"
			>
			</van-address-list>
			<div :style="{'width':'100%', 'box-sizing': 'border-box','padding': '0 16px' }">
				<van-button type="primary" block round @click="onSelectAddress" :style="{ 'margin-bottom': '50px' }">确定</van-button>
			</div>
		</van-popup>

		<van-popup v-model="showEditAddress" round position="bottom" :style="{ 'max-height': '80%' }">
			<UserAddressInfo :adrInfo="addressInfo" @callAfterSave="afterSaveAddress"></UserAddressInfo>
		</van-popup>

		<van-popup v-model="showPayTypes" position="bottom" :style="{ 'max-height': '80%' }">
			<van-cell-group>
				<van-cell :value="payParam.o_no" title="订单号">
				</van-cell>
				<van-cell :value="payParam.amount" title="金额">
					<template #right-icon>元</template>
				</van-cell>
				<van-cell :value="payParam.discount" title="已优惠" v-if="payParam.discount">
					<template #right-icon>元</template>
				</van-cell>
			</van-cell-group>
			<van-cell-group title="选择付款方式" class="pay_type_group">
				<van-radio-group v-model="payBy">
					<van-radio :name="p.values" v-for="(p,i) in payTypes" :key="i">
					{{p.describe}}
					<template #icon="props">
						<img class="pay_icon" :src="props.checked ? require('../../assets/img/icon/pay/'+p.values+'_active.png') : require('../../assets/img/icon/pay/'+p.values+'.png')" />
					</template>
					</van-radio>
				</van-radio-group>

				<van-button type="primary" block @click="toShoppingPay(1)" >马上付款</van-button>
				<van-button type="info" block @click="toShoppingPay(2)" >生成付款码</van-button>
				<van-button type="default" block @click="goOrderCenter()" >前往订单中心付款</van-button>
			</van-cell-group>
		</van-popup>

		<van-popup v-model="showPayQRCode" position="bottom" :style="{ 'max-height': '80%' ,'text-align':'center'}">
			<van-cell-group title="扫描二维码付款" class="pay_type_group">
				<div>金额：{{payParam.amount}}元{{payParam.discount?('，已优惠：'+payParam.discount+'元'):''}}</div>
				<vue-qr :text="payParam.url" :size="220" ref="Qrcode"></vue-qr>
				<div>订单号：{{payParam.o_no}}</div>
				<van-button type="danger" block @click="goOrderCenter" >完成付款</van-button>
			</van-cell-group>
		</van-popup>
	</div>
</template>

<script type="text/ecmascript-6">
import { chkImgType,goodUnit } from "@/utils/common.js";
import { List, Card, Divider, Search, Stepper,SwipeCell, SubmitBar,  Checkbox, CheckboxGroup,AddressList } from "vant";
import vueQr from "vue-qr";
import UserAddressInfo from "@/components/User/UserAddressInfo";

export default {
	name: "Cart",
	components: {
		"van-list": List,
		"van-card": Card,
		"van-divider":Divider,
		"van-search":Search,
		"van-stepper":Stepper,
		"van-swipe-cell":SwipeCell,
		"van-submit-bar":SubmitBar,
		"van-checkbox-group":CheckboxGroup,
		"van-checkbox":Checkbox,
		"van-address-list":AddressList,
		UserAddressInfo,
		"vue-qr":vueQr
	},
	data() {
		return {
			title: "购物车",
			attach_url:this.Conf.serverPre,
			items: [],
			goodUnitObj:{},
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			shoppingRst:[],
			shoppingAll:false,
			shoppingCart:{},
			storeExpress:{},
			expressStoreName:'',
			showExpress:false,
			storeOrderRemark:{},
			incExpress:false,

			showChosenAddress:false,
			chosenAddressId:-1,
			chosenAddress:[],
			addressInfoObj:{},

			showEditAddress:false,
			addressInfo:{},
			selAddressInfo:false,

			ordering:false,

			payTypes:[],
			showPayTypes:false,
			payBy:'',
			showPayQRCode:false,
			payParam:{},
			newWindonObj:null
		};
	},
	mounted() {
		// 获取浏览器可视区域高度
		this.winH = `${document.documentElement.clientHeight}`;
		window.onresize = function temp() {
			this.winH = `${document.documentElement.clientHeight}`;
		};
	},
	created() {
		this.getStateConfigs();
		this.goodUnitObj = goodUnit;
		
		this.$nextTick(() => {
			let myShoppingCartStorage = localStorage.getItem("myShoppingCart");
			this.shoppingCart = myShoppingCartStorage?JSON.parse(myShoppingCartStorage):{};
			for(var sid in this.shoppingCart){
				this.storeOrderRemark[sid] = "";
			}
		});
		this.getPayTypes();
	},
	methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
		goBack() {
			this.$router.go(-1);
		},
		stepStop(){},
		getPayTypes(){
			var params = {
				group: 'sys_pay'
			};
			var url = this.Conf.serverUrl + "Dictionary/options" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				this.payTypes = response.data.dicts;
			})
			.catch(error => {});
		},
		removeShoppingCart(s_id){
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "确定从购物车中删除？",
			})
			.then(() => {
				this.$delete(this.shoppingCart, s_id);
			})
			.catch(error => {});
		},
		removeShoppingCartGood(s_id,index){
			if(index){
				this.$delete(this.shoppingCart[s_id].cart, index);
				if(this.shoppingCart[s_id].cart.length == 0){
					this.$delete(this.shoppingCart, s_id);
				}
			}
		},
		submitShoppingCart(){
			if(this.ordering){
				this.$toast.fail("订单信息正在处理，请稍候！");
				return false;
			}
			
			if(!(this.u_id && this.token)){
				this.$dialog
				.confirm({
					title: "温馨提醒",
					message: "登录后即可下单？",
					showCancelButton:true,
					confirmButtonText:'马上登录',
					cancelButtonText:'再逛逛'
				})
				.then(() => {
					this.$router.push({ path: "/Login" });
					return false;
				})
				.catch(error => {
					return false;
				});
				return false;
			}

			let shoppingList = {};
			let submitOrders = [];
			for(var i in this.shoppingRst){
				if(!this.shoppingRst[i]) continue;
				let vals = this.shoppingRst[i].split("#");
				submitOrders.push(vals);
				if(shoppingList[vals[0].split("_")[1]]){
					shoppingList[vals[0].split("_")[1]]['goods'].push(this.shoppingCart[vals[0]].cart[vals[1]]);
				}else{
					shoppingList[vals[0].split("_")[1]] = {'goods':[this.shoppingCart[vals[0]].cart[vals[1]]], 'remark':this.storeOrderRemark[vals[0]].remark};
				}
			}

			if(submitOrders.length == 0){
				this.$toast.fail("请先添加订单商品！");
				return false;
			}
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "确定提交订单？",
			})
			.then(() => {
				this.ordering = true;
				let postData = {
					'store':shoppingList
				};
				if(this.u_id && this.token){
					postData['u_id'] = this.u_id;
				}
				if(this.selAddressInfo){
					postData['picker'] = this.selAddressInfo.name;
					postData['address'] = this.selAddressInfo.area + ' ' + this.selAddressInfo.address;
					postData['telphone'] = this.selAddressInfo.telphone;
					postData['lng'] = this.selAddressInfo.lng;
					postData['lat'] = this.selAddressInfo.lat;
				}
				let that = this;
				var url = this.Conf.serverUrl + "Store/order" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify({data:postData}))
				.then(response => {
					that.ordering = false;
					if (response.data.msg) {
						that.$toast.success(response.data.msg);
					}
					if(response.data.code == 200){
						that.$refs.shoppingCheckboxGroup.toggleAll({checked: false});
						for(var i in response.data.gids){
							let tmpsg = response.data.gids[i].split("_");
							for(var ii in that.shoppingCart['store_'+tmpsg[0]].cart){
								if(that.shoppingCart['store_'+tmpsg[0]].cart[ii].g_id == tmpsg[1]){
									that.removeShoppingCartGood('store_'+tmpsg[0], ii);
									break;
								}
							}
						}
						this.payParam = {
							o_no:response.data.o_no,
							amount:response.data.amount,
							discount:response.data.discount
						};
						this.showPayTypes = true;

					}
				})
				.catch(error => {
					that.ordering = false;
				});

			})
			.catch((error) => {});
		},
		chgShoppingAll(){
			this.shoppingAll = !this.shoppingAll;
			if(this.shoppingAll){
				this.$refs.shoppingCheckboxGroup.toggleAll({checked: true});
			}else{
				this.$refs.shoppingCheckboxGroup.toggleAll({checked: false});
			}
		},
		getExpress(sid, sname){
			this.showExpress = true;
			this.expressStoreName = sname;
			var params = {
				s_id:sid.split('_')[1],
			};
			let that = this;
			var url = this.Conf.serverUrl + "Store/express" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				this.storeExpress = response.data.express['express'];
			})
			.catch(error => {});
		},
		chkIncExpress(s,c){
			let shoppingOrderAmount = {};
			for(var i in c){
				if(!c[i]) continue;
				var amt = s[c[i].split("#")[0]].cart[c[i].split("#")[1]].g_price*s[c[i].split("#")[0]].cart[c[i].split("#")[1]].buys;
				if(shoppingOrderAmount[c[i].split("#")[0]]){
					shoppingOrderAmount[c[i].split("#")[0]] += amt;
				}else{
					shoppingOrderAmount[c[i].split("#")[0]] = amt;
				}
			}
			for(var sid in shoppingOrderAmount){
				if(shoppingOrderAmount[sid] >= s[sid].express){
					return true;
				}
			}
			return false
		},
		getMyAddress(){
			var params = {
				u_id:this.u_id,
				token:this.token,
			};
			let that = this;
			var url = this.Conf.serverUrl + "User/address" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				that.chosenAddress = [];
				that.chosenAddressId = -1;
				that.addressInfoObj = {};
				for(var i in response.data.address){
					that.chosenAddress.push({
					  id: response.data.address[i]['id'],
					  name: response.data.address[i]['name'],
					  tel: response.data.address[i]['telphone'],
					  address: response.data.address[i]['area']+' '+response.data.address[i]['address'],
					  isDefault: response.data.address[i]['defaults']==1,
					});
					that.addressInfoObj[response.data.address[i]['id']] = response.data.address[i];
				};
			})
			.catch(error => {});
		},
		onShowChosenAddress(){
			this.showChosenAddress = true;
			this.selAddressInfo = false;
			if(this.chosenAddress.length == 0){
				this.getMyAddress();
			}
		},
		onAddAddress(){
			this.addressInfo = {};
			this.showEditAddress = true;
		},
		onEditAddress(item, ind){
			this.addressInfo = this.addressInfoObj[item.id];
			this.showEditAddress = true;
		},
		onEditTempAddress(){
			this.addressInfo = this.selAddressInfo?this.selAddressInfo:{};
			this.showEditAddress = true;
		},
		afterSaveAddress(info){
			this.showEditAddress = false;
			if(info != undefined){
				this.selAddressInfo = info;
			}else{
				this.getMyAddress();
			}
		},
		onSelectAddress(){
			if(this.chosenAddressId == -1){
				this.$toast.fail("请选择或新增地址！");
				return false;
			}
			this.selAddressInfo = this.addressInfoObj[this.chosenAddressId];
			this.showChosenAddress = false;
		},
		toShoppingPay(t){
			if(this.payBy == ""){
				this.$toast.fail('请选择付款方式！');
				return false;
			}
			let postData = {
				o_no:this.payParam.o_no,
				s_type:t
			};
			postData.u_id = this.u_id;
			postData.token = this.token;
			postData.pay_by = this.payBy;
			if(t == 1){
				this.newWindonObj = window.open('_blank');
			}
			let that = this;
			var url = this.Conf.serverUrl + "User/pay" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(postData))
			.then(response => {
				if (response.data.msg) {
					that.$toast.success(response.data.msg);
				}
				if(response.data.code == 200){
					that.showPayTypes = false;
					that.payParam = response.data.data;
					if(that.payParam.s_type == 2){
						that.showPayQRCode = true;
					}else{
						if (window.plus) {
							plus.runtime.openURL(that.payParam.url);
						} else {
							//window.open(that.payParam.url);
							that.newWindonObj.location=that.payParam.url; // 后更改页面地址
						}
					}
				}
			})
			.catch(error => {});
		},
		goOrderCenter(){
			this.$router.push({
				path: "/Order"
			});
		}
	},
	filters:{
		sumOrderPrice(s,c){
			let total = 0;
			for(var i in c){
				if(!c[i]) continue;
				var amt = s[c[i].split("#")[0]].cart[c[i].split("#")[1]].g_price*s[c[i].split("#")[0]].cart[c[i].split("#")[1]].buys;
				total += amt;
			}
			return total*100;
		}
	},
	watch:{
	},
	beforeDestroy: function () {
		localStorage.setItem("myShoppingCart", JSON.stringify(this.shoppingCart));
	}
};
</script>




// WEBPACK FOOTER //
// src/components/Store/Cart.vue